import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHome, FaTools, FaEnvelope, FaLightbulb, FaUserCog } from "react-icons/fa";
import { GiTechnoHeart } from "react-icons/gi";
import "./navbar.css";
import logo from "./LOGO_DOMOTIC_PRO.png";
import video1 from "./navbar_video_1.mp4";

const DomoticNavbar = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [hoverSoluciones, setHoverSoluciones] = useState(false);
  const [hoverPartners, setHoverPartners] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const videoRef = useRef(null);
  const navbarRef = useRef(null);
  const navigate = useNavigate(); // Añade esto

  // Lista de soluciones
  const soluciones = [
    { name: "REDES Y NETWORKING", path: "/RedesNetworking" },
    { name: "SISTEMAS POS", path: "/SistemasPOs" },
    { name: "ENERGÍA SOLAR", path: "/SolarSystems" },
    { name: "PUERTAS DE SEGURIDAD", path: "/Puertas-Seguridad" },
    { name: "PARQUEADEROS INTELIGENTES", path: "/IntelligentParking" },
    { name: "PANTALLAS EDUCATIVAS", path: "/Pantallas-Señalización" },
    { name: "LICENCIAMIENTO DE SOFTWARE", path: "/licenciamiento-software" },
    { name: "ELECTROSEGURIDAD Y CCTV", path: "/SecurityCctv" },
    { name: "CÓMPUTO Y VIDEOCONFERENCIA", path: "/ComputoVideoConferencia" }
  ];
  // Función para manejar clic en contacto - CORREGIDA
  const handleContactClick = (e) => {
    // Si ya estamos en la página de inicio (/), simplemente hacemos scroll
    if (pathname === "/") {
      e.preventDefault();
      const contactSection = document.getElementById("contacto");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
        // Actualizar URL con el hash
        window.history.pushState(null, null, "#contacto");
      }
    }
    // Si estamos en otra página
    else {
      navigate("/#contacto");
      
      // Esperar a que la página se cargue y luego hacer scroll
      const waitForLoad = () => {
        const contactSection = document.getElementById("contacto");
        if (contactSection) {
          contactSection.scrollIntoView({ 
            behavior: "smooth",
            block: "start"
          });
        } else {
          // Si no se encuentra, intentar de nuevo después de un breve tiempo
          setTimeout(waitForLoad, 50);
        }
      };
      
      setTimeout(waitForLoad, 100);
    }
  };


    // Nuevo estado para controlar si el menú de soluciones está abierto
    const [solucionesOpen, setSolucionesOpen] = useState(false);
    const [partnersOpen, setPartnersOpen] = useState(false);
  
    // Función para alternar el menú de soluciones
    const toggleSoluciones = () => {
      setSolucionesOpen(!solucionesOpen);
      // Cerramos partners si está abierto
      if (partnersOpen) setPartnersOpen(false);
    };
  
    // Función para alternar el menú de partners
    const togglePartners = () => {
      setPartnersOpen(!partnersOpen);
      // Cerramos soluciones si está abierto
      if (solucionesOpen) setSolucionesOpen(false);
    };
  
    // Cerrar menús al hacer clic fuera o cambiar de página
    useEffect(() => {
      setSolucionesOpen(false);
      setPartnersOpen(false);
    }, [pathname]);
  // Efecto para manejar el scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Efecto para manejar el video
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const playVideo = () => {
        video.muted = true;
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.warn("Autoplay prevented:", error);
            // Intenta reproducir después de una interacción del usuario
            document.addEventListener('click', () => video.play(), { once: true });
          });
        }
      };

      // Intenta reproducir inmediatamente
      playVideo();

      // Si falla, espera a que el video pueda cargar
      video.addEventListener('loadedmetadata', playVideo);
      return () => video.removeEventListener('loadedmetadata', playVideo);
    }
  }, []);

  // Cerrar menú móvil al cambiar de página
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname]);

  // Manejar clic fuera del menú móvil
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (pathname === "/" && window.location.hash === "#domotic-contact") {
      const contactSection = document.getElementById("domotic-contact");
      if (contactSection) {
        setTimeout(() => {
          contactSection.scrollIntoView({ behavior: "smooth" });
        // Limpiar el hash para que si el usuario refresca no haga scroll automático
          window.history.replaceState(null, null, ' ');
        }, 100);
      }
    }
  }, [pathname]);

  return (
    <div className="domotic-navbar-container" ref={navbarRef}>
      {/* Video de fondo - SIEMPRE VISIBLE */}
      <div className={`video-watermark ${scrolled ? "scrolled" : ""}`}>
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="watermark-video"
        >
          <source src={video1} type="video/mp4" />
          Tu navegador no soporta videos HTML5.
        </video>
      </div>

      {/* Navbar principal */}
      <nav className={`domotic-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Logo Domotic" className="domotic-logo" />
          </Link>

          {/* Menú para desktop */}
          <ul className={`domotic-nav-links ${mobileMenuOpen ? "mobile-active" : ""}`}>
            <li>
              <Link 
                to="/" 
                className={`nav-link ${pathname === "/" ? "active" : ""}`}
              >
                <FaHome className="nav-icon" />
                <span>INICIO</span>
                <div className="nav-underline"></div>
              </Link>
            </li>
            
            <li>
              <Link 
                to="/Nosotros" 
                className={`nav-link ${pathname === "/Nosotros" ? "active" : ""}`}
              >
                <FaUserCog className="nav-icon" />
                <span>QUIÉNES SOMOS</span>
                <div className="nav-underline"></div>
              </Link>
            </li>
            
           {/* Menú desplegable Soluciones - MODIFICADO */}
        <li 
          className="nav-item-with-menu"
          onClick={toggleSoluciones}
          style={{ cursor: 'pointer' }} // Añadimos cursor de manita
        >
          <div className="nav-link">
            <FaTools className="nav-icon" />
            <span>SOLUCIONES</span>
            <div className="nav-underline"></div>
          </div>
          
          {solucionesOpen && (
            <div className="hover-menu solutions-menu">
              <ul className="hover-menu-list">
                {soluciones.map((solucion, index) => (
                  <li key={index}>
                    <Link 
                      to={solucion.path}
                      className="hover-menu-item"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setSolucionesOpen(false);
                      }}
                      style={{ cursor: 'pointer' }} // Añadimos cursor de manita
                    >
                      {solucion.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </li>
            
            {/* Menú desplegable Partners - MODIFICADO */}
        <li 
          className="nav-item-with-menu"
          onClick={togglePartners}
          style={{ cursor: 'pointer' }} // Añadimos cursor de manita
        >
          <div className="nav-link">
            <GiTechnoHeart className="nav-icon" />
            <span>PARTNERS</span>
            <div className="nav-underline"></div>
          </div>
          
          {partnersOpen && (
            <div className="hover-menu partners-menu">
              <div className="partners-content">
                <p>Explora nuestras alianzas estratégicas con las mejores marcas del mercado.</p>
                <Link 
                  to="/Partners" 
                  className="partners-link"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    setPartnersOpen(false);
                  }}
                  style={{ cursor: 'pointer' }} // Añadimos cursor de manita
                >
                  Ver todos los partners
                </Link>
              </div>
            </div>
          )}
        </li>
            
            <li>
            <Link 
  to="/#contacto"  // Cambiado a #contacto
  className={`nav-link ${pathname === "/" && window.location.hash === "#contacto" ? "active" : ""}`}
  onClick={handleContactClick}
>
  <FaEnvelope className="nav-icon" />
  <span>CONTACTO</span>
  <div className="nav-underline"></div>
</Link>
      </li>
          </ul>

          {/* Botón del menú móvil */}
          <button 
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <span style={{fontSize: '1.8rem'}}>✕</span>
            ) : (
              <span style={{fontSize: '1.8rem'}}>☰</span>
            )}
          </button>
        </div>
      </nav>
    </div>
  );
};

export default DomoticNavbar;